export enum ModalSize {
    Xl = 'xl',
    Lg = 'lg',
    Md = 'md',
    Sm = 'sm'
}
